/* eslint-disable react/react-in-jsx-scope */
import CallForProjectsCreateProject from "@/pages/submit/CallForProjectsCreateProject";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

const CustomProjectForm = () => {
  const [searchParams] = useSearchParams();
  const projectId = useMemo(() => {
    const raw = searchParams.get("projectId");
    const parsed = raw ? Number(raw) : NaN;
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  }, [searchParams]);
  const returnPath = useMemo(() => {
    const rawProgramId = searchParams.get("programId");
    const parsedProgramId = Number(rawProgramId);
    if (Number.isFinite(parsedProgramId) && parsedProgramId > 0) {
      return `/dashboard/program/${parsedProgramId}`;
    }
    return "/dashboard/programs";
  }, [searchParams]);

  return (
    <CallForProjectsCreateProject
      listPath={returnPath}
      projectId={projectId}
      hardRedirectOnSubmit
    />
  );
};

export default CustomProjectForm;
